import { useAuth } from "../../../Context/AuthContext";
import { isValidArray } from "../../../Layout/Common/common";
import { GridViewItem } from "./item/gridViewItem";
import { ListViewItem } from "./item/listViewItem";

export const NewsFlyersFeaturedContainer = ({ viewBox, CategoryList, pageNo }) => {
  const itemsPerPage = 12;
  const indexOfLastItem = pageNo * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const { userId } = useAuth();
  if (!isValidArray(CategoryList)) {
    return <></>;
  }

  const baseDirectory = process.env.REACT_APP_publicUrl || window.location.origin;

  return (
    <div className="row">
      {isValidArray(CategoryList) &&
        CategoryList.slice(0, 4).map((item) => {
          return viewBox === "grid" ? (
            <GridViewItem key={item.categoryId} row={item} />
          ) : (
            <ListViewItem key={item.categoryId} row={item} />
          );
        })}
    </div>
  );
};
